import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionHead } from "../motion";
import { FAQS } from "../../content";

export function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="border-y border-ink/10 bg-warmwhite">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-20 lg:py-24">
        <SectionHead eyebrow="FAQ" title="Frequently Asked Questions" align="center" />
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-ink/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-lg text-ink transition-colors hover:text-cherry hover:no-underline sm:text-xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="pb-5 text-base leading-relaxed text-ink/70">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
